import { useTranslation } from 'react-i18next';

const COUNTRIES = [
  { code: 'ma', name: 'Maroc' }, { code: 'fr', name: 'France' }, { code: 'sn', name: 'Sénégal' },
  { code: 'be', name: 'Belgique' }, { code: 'es', name: 'Espagne' }, { code: 'gb', name: 'UK' },
  { code: 'it', name: 'Italie' }, { code: 'ca', name: 'Canada' }, { code: 'us', name: 'USA' },
  { code: 'de', name: 'Allemagne' }, { code: 'ch', name: 'Suisse' }, { code: 'pt', name: 'Portugal' },
  { code: 'nl', name: 'Pays-Bas' }, { code: 'tn', name: 'Tunisie' }, { code: 'dz', name: 'Algérie' },
  { code: 'ci', name: "Côte d'Ivoire" }, { code: 'cm', name: 'Cameroun' }, { code: 'sa', name: 'Arabie' },
  { code: 'ae', name: 'Émirats' }, { code: 'qa', name: 'Qatar' },
];

export default function WorldCoverage() {
  const { t } = useTranslation();
  return (
    <section className="py-12 sm:py-16 md:py-24 bg-gradient-to-b from-background via-card/30 to-background relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent rounded-full blur-3xl" />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-8 sm:mb-12">
          <div className="inline-flex items-center gap-2 bg-primary/10 border border-primary/20 rounded-full px-4 py-2 mb-4 sm:mb-6">
            <span className="text-sm font-medium text-primary">{t('world.badge')}</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4">
            <span className="text-gradient">{t('world.title1')}</span><br />
            <span className="text-foreground">{t('world.title2')}</span>
          </h2>
          <p className="text-muted-foreground text-base sm:text-lg md:text-xl max-w-3xl mx-auto leading-relaxed px-2">{t('world.desc')}</p>
        </div>
        <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
          {COUNTRIES.map(({ code, name }) => (
            <div key={code} className="flex flex-col items-center p-4 rounded-2xl bg-card/50 border border-border/50 backdrop-blur-sm hover:border-primary/50 hover:bg-card/80 transition-all duration-300 group hover:scale-105 cursor-default">
              <img src={`https://flagcdn.com/w80/${code}.png`} alt={name} className="w-16 h-12 object-cover rounded mb-2 group-hover:scale-110 transition-transform" loading="lazy" />
              <span className="text-sm font-medium text-foreground">{name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
